"use strict";
class Course {
    constructor() {
        this.sectionPositions = [];
        this.ticking = false;
        this.is_scrolled = false;
        const course = document.querySelector("#course");
        if (course === null)
            return;
        this.init();
    }
    init() {
        this.updateSectionPositions();
        this.bindEvents();
        this.updateActiveSection();
        document.addEventListener("DOMContentLoaded", this.setupEventListeners.bind(this));
    }
    /**
     * セクションの位置情報を更新
     */
    updateSectionPositions() {
        // data-nav-targetに対応する要素を取得
        const navLinks = document.querySelectorAll(".courseNav__main a");
        this.sectionPositions = Array.from(navLinks)
            .map((link) => {
            const targetId = link.getAttribute("data-nav-target");
            const section = document.getElementById(targetId || "");
            return {
                id: targetId || "",
                position: section ? section.offsetTop - 100 : 0, // ヘッダーの高さなどを考慮してオフセット
            };
        })
            .filter((item) => item.position > 0); // 有効な位置情報のみを保持
    }
    /**
     * イベントのバインド
     */
    bindEvents() {
        // スクロールイベント
        window.addEventListener("scroll", this.onScroll.bind(this));
        // リサイズイベント (debounce処理付き)
        let resizeTimer;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(() => {
                this.updateSectionPositions();
                this.updateActiveSection();
            }, 250);
        });
        // クリックイベント
        document
            .querySelectorAll(".courseNav__main a")
            .forEach((link) => {
            link.addEventListener("click", this.onNavClick.bind(this));
        });
    }
    /**
     * スクロールハンドラ
     */
    onScroll() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.updateActiveSection();
                this.ticking = false;
            });
            this.ticking = true;
        }
        /* const courseNav = document.querySelector("#courseNav");
        const courseMv = document.getElementById("courseMv");
        if (courseMv === null || courseNav == null) return;
        const courseMvHeight = courseMv.offsetHeight;
        const triggerPosition = courseMv.offsetTop + courseMvHeight * 0.8;
    
        if (window.scrollY > triggerPosition) {
          if (!this.is_scrolled) {
            //画面横幅を取得
            const screenWidth = window.innerWidth;
            if (screenWidth > 768) {
              courseNav.classList.add("is-active");
            }
            this.is_scrolled = true;
          }
        } else {
          courseNav.classList.remove("is-active");
          this.is_scrolled = false;
        } */
    }
    /**
     * アクティブセクションの更新
     */
    updateActiveSection() {
        const scrollPosition = window.scrollY;
        let activeId = "";
        // スクロール位置に基づいて現在のセクションを特定
        for (let i = 0; i < this.sectionPositions.length; i++) {
            const current = this.sectionPositions[i];
            const next = this.sectionPositions[i + 1];
            if (scrollPosition >= current.position &&
                (!next || scrollPosition < next.position)) {
                activeId = current.id;
                break;
            }
        }
        // 最後のセクションの特別処理
        const lastSection = this.sectionPositions[this.sectionPositions.length - 1];
        if (scrollPosition >= lastSection.position) {
            activeId = lastSection.id;
        }
        if (activeId) {
            this.updateNavigation(activeId);
        }
    }
    /**
     * ナビゲーションの状態を更新
     */
    updateNavigation(activeSectionId) {
        // すべてのナビゲーションからアクティブ状態を削除
        document.querySelectorAll(".courseNav__main li").forEach((item) => {
            item.classList.remove("active");
        });
        document.querySelectorAll(".courseNav__main a").forEach((link) => {
            link.classList.remove("active");
        });
        // アクティブなセクションに対応するナビゲーションをアクティブ化
        const activeLink = document.querySelector(`.courseNav__main a[data-nav-target="${activeSectionId}"]`);
        if (activeLink) {
            const parentLi = activeLink.closest("li");
            if (parentLi) {
                parentLi.classList.add("active");
            }
            activeLink.classList.add("active");
        }
    }
    /**
     * ナビゲーションクリック時の処理
     */
    onNavClick(e) {
        e.preventDefault();
        const link = e.currentTarget;
        const targetId = link.getAttribute("data-nav-target");
        if (!targetId)
            return;
        const targetSection = document.getElementById(targetId);
        if (!targetSection)
            return;
        // スクロール位置の調整（ヘッダーの高さなどを考慮）
        const targetPosition = targetSection.offsetTop - 100;
        window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
        });
    }
    /**
     * インスタンスの破棄
     */
    destroy() {
        window.removeEventListener("scroll", this.onScroll.bind(this));
        document
            .querySelectorAll(".courseNav__main a")
            .forEach((link) => {
            link.removeEventListener("click", this.onNavClick.bind(this));
        });
    }
    setupEventListeners() {
        const courseNav = document.querySelector("#courseNav");
        const openButton = document.querySelector(".courseNav-open");
        const closeButton = document.querySelector(".courseNav-close");
        // ナビゲーションを開く
        openButton.addEventListener("click", (e) => {
            e.preventDefault();
            courseNav.classList.add("is-active");
        });
        // ナビゲーションを閉じる
        closeButton.addEventListener("click", (e) => {
            e.preventDefault();
            console.log("close");
            courseNav.classList.remove("is-active");
        });
        // オプション: ESCキーでも閉じられるように
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && courseNav.classList.contains("is-active")) {
                courseNav.classList.remove("is-active");
            }
        });
    }
}
new Course();
/*
document.addEventListener("DOMContentLoaded", () => {
  // 必要な要素の取得
  const courseNav = document.querySelector("#courseNav");
  const openButton = document.querySelector(".courseNav-open");
  const closeButton = document.querySelector(".courseNav-close");

  // ナビゲーションを開く

  openButton!.addEventListener("click", (e) => {
    e.preventDefault();
    courseNav!.classList.add("is-active");
  });

  // ナビゲーションを閉じる
  closeButton!.addEventListener("click", (e) => {
    e.preventDefault();
    console.log("close");
    courseNav!.classList.remove("is-active");
  });

  // オプション: ESCキーでも閉じられるように
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && courseNav!.classList.contains("is-active")) {
      courseNav!.classList.remove("is-active");
    }
  });
});
 */
